/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, FieldProps, TextField } from 'framework/ui/field';

const ContractWorkRateField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const displayedValue = `${getValue()}%`;

  return <TextField {...props} value={displayedValue} />;
};

export default ContractWorkRateField;
